import { initGraphQLTada } from 'gql.tada';
import type { introspection } from '../../graphql-env';

export const graphql = initGraphQLTada<{
  disableMasking: true;
  introspection: introspection;
  scalars: {
    PagePathname: string;
    Uri: string;
  };
}>();
